import { elements, modifiers } from '#components/generics/js/styles.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import all from '@mailobj-browser/front/js/selectors/all.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { scope } from '#components/generics/js/selectors/scope.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import * as utilities from '#utilities/js/styles.js'

const onInput = object(listener, {
  type: input,
  passive,
  task: (
    control
  ) => {
    const wrapper = closest(`[data-contract~="field.conditional"]`, control)
    const scopeJson = scope(control)
    const { conditional } = scopeJson
    let conditionalKey

    if (control.checked !== undefined) {
      conditionalKey = control.checked === true ? 'checked' : null
    } else {
      conditionalKey = control.value
    }

    for (const conditionalNames of Object.values(conditional)) {
      for (const conditionalName of conditionalNames) {
        const conditionalControl = one(`.${elements.new_field_control}[name="${conditionalName}"]`, wrapper)

        if (conditionalControl) {
          const conditionalControlField = closest(`.${elements.new_field}`, conditionalControl)
          if (conditional[conditionalKey] && conditional[conditionalKey].includes(conditionalName)) {
            conditionalControl.disabled = false
            conditionalControlField.disabled = false
            conditionalControlField.classList.remove(utilities.modifiers.display.none)
            conditionalControlField.classList.remove(modifiers.new_field.new_disabled)
          } else {
            conditionalControl.disabled = true
            conditionalControlField.disabled = true
            conditionalControlField.classList.add(utilities.modifiers.display.none)
            conditionalControlField.classList.add(modifiers.new_field.new_disabled)
          }
        }
      }
    }
  }
})

export default (wrapper) => {
  const controls = all(`.${modifiers.new_field_control.new_conditional}`, wrapper)

  for (const control of controls) {
    onInput.listen(control)
  }
}
